"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableContainer = _interopRequireDefault(require("@material-ui/core/TableContainer"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      borderRadius: '4px'
    },
    tableWrapper: {
      marginTop: theme.spacing(2)
    }
  };
});
function SttTable(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_TableContainer["default"], {
    component: _Paper["default"],
    elevation: 0,
    className: classes.tableWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Table["default"], props));
}
var _default = SttTable;
exports["default"] = _default;